<template>
  <div>
    <subscribe :book="item"></subscribe>
    <div class="book_mask" id="mask" v-if="item.BookID || item.BookGroupID">
      <div class="box-hover">
        <a v-if="!item.IsUpcoming" :href="'book?id='+(item.BookID || item.BookGroupID)+'&isGroup='+(!item.BookID>0)+'&isSerials='+isSerials"><div class="book_mask_btn">書籍資訊</div></a>
        <a v-if="item.IsUpcoming" :href="'book?id='+(item.BookID || item.BookGroupID)+'&isGroup='+(!item.BookID>0)+'&isSerials='+isSerials"><div class="book_mask_btn_wait">書籍資訊</div></a>
        <a v-if="(isSerials || item.IsSerial) && !item.IsUpcoming" :href="`reader/FireBase3.html?bookID=${newestID||item.BookID}&isLogin=`+isLogin+'&isSerial=true'" target="_blank" >
          <div class="book_mask_btn book_mask_btn2">直接閱讀</div>
        </a>
        <!-- 如果書本資料裡面沒有回傳 isSerials 這個參數，我將無法判斷本書是否是連載 -->
        <a v-if="(!isSerials || !item.IsSerial) && item.BookID && !item.IsUpcoming" :data-remodal-target="'modal-'+(item.BookID)"><div class="book_mask_btn book_mask_btn2">快速結帳</div></a>
        <a v-if="(!isSerials || !item.IsSerial) && newestID && !item.IsUpcoming" :data-remodal-target="'modal-'+(newestID)"><div class="book_mask_btn book_mask_btn2">快速結帳</div></a>
      </div>
    </div>
    <!-- <div class="recommend_icon"></div> -->
    <a class="thumb" :href="(item.BookID) ? 'book?id='+item.BookID+'&isGroup=false'+'&isSerials='+isSerials : (item.BookGroupID) ? 'book?id='+item.BookGroupID+'&isGroup=true'+'&isSerials='+isSerials: '' " @click="checkBook(item)">
      <div class="bookCover_Out" id="bookCover_Out">
        <img :title="item.Title" :src="item.CoverURL || item.BookCoverURL" />
      </div>
    </a>
    <div class="book_slider_wrap">
        <div class="book_slider_leaderboard leaderboard_no1" v-if="item.Rank && item.Rank==1">{{item.Rank}}</div>
        <div class="book_slider_leaderboard leaderboard_no2" v-if="item.Rank && item.Rank==2">{{item.Rank}}</div>
        <div class="book_slider_leaderboard leaderboard_no3" v-if="item.Rank && item.Rank==3">{{item.Rank}}</div>
        <div class="book_slider_leaderboard" v-if="item.Rank && item.Rank>3">{{item.Rank}}</div>
        <div class="book_slider_leaderboard_name" v-if="item.BookTitle"><span v-if="item.BookID || item.BookGroupID">{{item.BookTitle}}</span></div>
        <div class="book_slider_name"><span>{{item.Title}}</span></div>
        <div class="book_slider_no" v-if="item.Vol">{{item.Vol}}</div>
        <!-- <div class="book_slider_price" v-show="book.BookPrice">{{book.BookPrice && book.BookPrice.Price}}</div> -->
        <!-- <div class="book_slider_price price_sale" v-if="item.BookPrice && item.SerialTag && !item.SerialTag.ID">{{item.BookPrice.Price}}</div> -->
        <div v-if="(typeof item.BookPrice !== 'undefined') && item.BookPrice !== null && !item.IsSerial">
          <div v-if="item.BookPrice.IsPromotion">
            <!-- <div class="book_slider_price price_sale price_oldSale"  v-if="item.BookPrice.Price">{{item.BookPrice.OrgPrice}}</div> -->
            <div class="book_slider_price price_onSale"  v-if="item.BookPrice.Price>=0">{{item.BookPrice.Price}}</div>
          </div>
          <div class="book_slider_price price_sale"  v-if="item.BookPrice.Price>=0 && !item.BookPrice.IsPromotion">{{item.BookPrice.Price}}</div>
        </div>
        <div class="new_manga_icon" v-if="item.SerialTag && item.SerialTag.ID"><a :href="`/topic?id=${item.SerialTag.ID}`"><div class="news_icon_blue">{{item.SerialTag.Title}}</div></a></div>
      </div>
    <remodal v-if="(!isSerials || !item.IsSerial)" :book="item" v-bind:newestID="newestID"></remodal>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus, READER,sourceTree} from './config.js'
import {vueConfig} from './main.js'
import user from './user.js'
import Remodal from './Remodal.vue'
import Subscribe from './Subscribe.vue'
import firebase from '../node_modules/firebase/app'

export default {
  name: 'Book',
  props: ["book", "index", "serials"],
  data () {
    return {
      item: this.book,
      newestID:""
    }
  },
  methods: {
    ...user,
    checkBook (book) {
      if (!book.BookID && !book.BookGroupID) alert("沒有找到書本資料，請聯絡管理員。")
    },
    getNewestBookID(item){
      return new Promise((resolve, reject) => {
        axios.get(`${API_URL}/Book/BookVol/${item.BookGroupID}?isSerial=${item.IsSerial}`, this.getBearerToken()).then(response =>{
          if(response.data.length>0){
            for(var i=0 ; i<response.data.length; i++){
              if(!(response.data[response.data.length-(1+i)].IsUpcoming)){
                this.newestID = response.data[response.data.length-(1+i)].BookID
                i = response.data.length
                resolve(this.newestID)
              }
            }
          }
        }).catch(e => {
          // console.log(e)
          // this.errors.push(e)
          console.log(item)
          console.log(e.message)
        })
      })
    },
    getBearerToken: function () {
      return {
        headers: {'Authorization': 'bearer ' + sourceTree.token}
      }
    }
  },
  computed: {
    isSerials () {
      // return (document.querySelector("#root-class")) ? document.querySelector("#root-class").innerText === 'serials' : ''
      return this.serials
    },
    isLogin (){
        var user = firebase.auth().currentUser
        if(user!=null){
          return "true"
        }else{
          return "false"
        }
    },
  },
  mounted () {
    if(!this.item.BookID){
      this.getNewestBookID(this.item)
    }
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  },
  components: {
    Remodal,
    Subscribe
  }
}
</script>



// WEBPACK FOOTER //
// src/Book.vue